import { nerdNetworkBaseQuery } from "@nerdjs/nerd-network";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const local420Api = createApi({
  reducerPath: "local420Api",
  baseQuery: (args, api) => baseQuery(args, api, { service: "local420" }),
  endpoints: () => ({}),
  tagTypes: [
    "gigs",
    "gigPieces",
    "contractors",
    "projects",
    "venues",
    "seasons",
    "members",
    "memberInstruments",
    "contacts",
    "emails",
    "customFields",
  ],
});
